<mat-tab-group #matTabGroup (selectedTabChange)="onTabChange($event)" class="task-tab">
  <mat-tab>
    <ng-template mat-tab-label>
      <span id="teras-badge" [matBadge]="0" matBadgeOverlap="false" matBadgeColor="warn">Tab 1</span>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span id="teras-badge" [matBadge]="5" matBadgeOverlap="false" matBadgeColor="warn">Tab 2</span>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span id="teras-badge" [matBadge]="0" matBadgeOverlap="false" matBadgeColor="warn">Tab 3</span>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span id="teras-badge" [matBadge]="3" matBadgeOverlap="false" matBadgeColor="warn">Tab 4</span>
    </ng-template>
  </mat-tab>
</mat-tab-group>